// 操作localStorage本地缓存
import * as localKeys from "@/global/constant";
interface ILocalCache {
  setCache: (key: string, value: any) => void;
  getCache: (key: string) => unknown;
  deleteCache: (key: string) => void;
  clearCache: () => void;
}
class LocalCache implements ILocalCache {
  setCache(key: string, value: any) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
  getCache(key: string) {
    const value = window.localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  }
  deleteCache(key: string) {
    window.localStorage.removeItem(key);
  }
  clearCache() {
    window.localStorage.clear();
  }
  clearAllCache(excludes: string[] = []) {
    for (const key in localKeys) {
      !excludes.includes(key) && this.deleteCache(localKeys[key]);
    }
  }
}

export default new LocalCache();
